import { render, staticRenderFns } from "./CustomButtonFive.vue?vue&type=template&id=4036584a&"
import script from "./CustomButtonFive.vue?vue&type=script&lang=js&"
export * from "./CustomButtonFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports